import { render, staticRenderFns } from "./DiscountsList.vue?vue&type=template&id=747e67ae&scoped=true"
import script from "./DiscountsList.vue?vue&type=script&lang=js"
export * from "./DiscountsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747e67ae",
  null
  
)

export default component.exports